export default __webpack_public_path__ + "static/media/question.0d0fde17.svg";